import { render, staticRenderFns } from "./ArticlesInCart.vue?vue&type=template&id=5dc31296&scoped=true"
import script from "./ArticlesInCart.vue?vue&type=script&lang=js"
export * from "./ArticlesInCart.vue?vue&type=script&lang=js"
import style0 from "./ArticlesInCart.vue?vue&type=style&index=0&id=5dc31296&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dc31296",
  null
  
)

export default component.exports